import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import Pagination         from 'app/components/common/pagination';
import ScrollTable        from 'app/components/common/scroll-table';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/company-admin/forms';
import UiFormsDuck        from 'app/ducks/company-admin/ui-forms';
import formsHelpers       from 'app/helpers/forms';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';

import Builder from 'app/components/company-admin/grant-system/builder-program-landing-page';
import GrantSysDuck        from 'app/ducks/company-admin/grant-system';
import ProgramProfile        from 'app/components/grant-system/program-profile';

class CadminPageGrantEditLanding extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {company, program} = this.props;
    if (!company) return <PageLoading />;

    const builder = program ? <Builder program={program} /> : null;

    return (
      <CadminLayout company={company} activeItem="grant-programs" builder={builder}>
        <Meta title={`Edit Landing Page | Millie`} />
        {!!program && (
          <ProgramProfile program={program} editMode />
        )}
        {/* <pre>{JSON.stringify(this.props,null,4)}</pre> */}
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  persistedProgram: GrantSysDuck.Slx.pathProgram(state),
  program: GrantSysDuck.Slx.bldrLandProg(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CadminPageGrantEditLanding);
